import { useReducer } from 'react';
import filtersStore, { INITIAL_FILTERS } from '../store/filters/filtersStore';
import {
  FiltersStoreKind,
  FiltersStoreType,
} from 'src/store/filters/filtersStore.types';

export interface FiltersHook {
  state: FiltersStoreType;
  actions: {
    setFilters: (filters: FiltersStoreType) => void;
    setFiltersRatingMinRatingMax: (
      ratingMin: number,
      ratingMax: number
    ) => void;
    setFiltersSearchTerm: (searchTerm: string) => void;
    setDropDownItem: (key: string, value: string[]) => void;
    resetFilters: () => void;
    setPage: (value: number) => void;
    setSize: (value: number) => void;
    setSearchTerm: (value: string) => void;
    setSorting: (value: string) => void;
  };
}

const useFiltersHook = (): FiltersHook => {
  const [state, dispatch] = useReducer(filtersStore, INITIAL_FILTERS);

  const setFilters = (filters: FiltersStoreType): void => {
    dispatch({
      type: FiltersStoreKind.INITIAL,
      payload: filters,
    });
  };

  const setFiltersRatingMinRatingMax = (
    ratingMin: number,
    ratingMax: number
  ): void => {
    dispatch({
      type: FiltersStoreKind.UPDATE_RATING,
      payload: { ratingMin, ratingMax },
    });
  };

  const setFiltersSearchTerm = (searchTerm: string): void => {
    dispatch({
      type: FiltersStoreKind.UPDATE_SEARCH_TERM,
      payload: searchTerm,
    });
  };

  const setDropDownItem = (key: string, value: string[]): void => {
    dispatch({
      type: FiltersStoreKind.UPDATE_DROPDOWN,
      payload: { key, value },
    });
  };

  const resetFilters = (): void => {
    dispatch({
      type: FiltersStoreKind.INITIAL,
      payload: INITIAL_FILTERS,
    });
  };

  const setPage = (value: number): void => {
    dispatch({
      type: FiltersStoreKind.UPDATE_PAGE,
      payload: value,
    });
  };

  const setSize = (value: number): void => {
    dispatch({
      type: FiltersStoreKind.UPDATE_SIZE,
      payload: value,
    });
  };

  const setSearchTerm = (value: string): void => {
    dispatch({
      type: FiltersStoreKind.UPDATE_SEARCH_TERM,
      payload: value,
    });
  };

  const setSorting = (value: string): void => {
    dispatch({
      type: FiltersStoreKind.UPDATE_SORTING,
      payload: value,
    });
  };

  return {
    state,
    actions: {
      setFilters,
      setFiltersSearchTerm,
      setFiltersRatingMinRatingMax,
      setDropDownItem,
      resetFilters,
      setPage,
      setSize,
      setSearchTerm,
      setSorting,
    },
  };
};

export default useFiltersHook;
